export default __webpack_public_path__ + "static/favicon-2123e2f129783864e4b9082ca3179ee3.ico";